module.exports = __webpack_public_path__ + "img/photo-0078.ecdd846f.jpg";